import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Box, Image, Flex, Text, Icon, getPaletteColor } from 'pcln-design-system'
import styled from 'styled-components'

const BannerContainer = styled(Box)`
  margin-bottom: 10px;
  cursor: default;
`

const ImageContainer = styled.div`
  padding: 5px;
  background-color: ${getPaletteColor('background.lightest')};
  min-width: 50px;
  height: 40px;
  border: 1px solid #287cf6;
  border-radius: ${(props) => props.theme.borderRadii.lg};
  cursor: pointer;

  ${(props) => props.theme.flyQueries.tabletlg} {
    height: 48px;
    min-width: 58px;
  }
`

const StyledImage = styled(Image)`
  height: 30px;
  width: 40px;

  ${(props) => props.theme.flyQueries.tabletlg} {
    height: 38px;
    width: 46px;
  }
`

const SponsorMessage = styled.div`
  align-self: center;
  padding-left: 10px;
  font-family: Montserrat, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 16px;
  letter-spacing: normal;
  color: ${getPaletteColor('text.lightest')};
  cursor: pointer;

  ${(props) => props.theme.flyQueries.tabletlg} {
    font-size: 14px;
    line-height: 20px;
  }
`

const CloseButton = styled(Icon)`
  margin-left: auto;
  cursor: pointer;
  align-self: center;
  padding: 4px 8px;
  margin-right: 8px;
`

const UnderlineText = styled(Text.span)`
  text-decoration: underline;
`

const DesktopPrice = styled.span`
  display: inline-block;
  ${(props) => props.theme.flyQueries.desktoplg} {
    display: none;
  }
`

const LargeDesktopPrice = styled.span`
  display: none;
  ${(props) => props.theme.flyQueries.desktoplg} {
    display: inline-block;
  }
`

export default class SponsoredCarrier extends Component {
  constructor(props) {
    super()

    this.hideBanner = this.hideBanner.bind(this)
    this.filterAirline = this.filterAirline.bind(this)
    this.state = {
      showBanner: props.showBanner,
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.showBanner !== this.props.showBanner) {
      this.setState({
        showBanner: nextProps.showBanner,
      })
    }
  }

  hideBanner() {
    this.setState({
      showBanner: false,
    })
    this.props.flyGaLogic.fire.sponsoredCarrier('Close')
  }

  /* istanbul ignore next */
  filterAirline() {
    window.angular.element(document.querySelector(`${this.props.selectNoneSelector}`)).triggerHandler('click')
    window.angular
      .element(document.querySelector(`${this.props.filterAirlineSelector}`))
      .triggerHandler('click')
    this.props.flyGaLogic.fire.sponsoredCarrier('Filter')
  }

  render() {
    return (
      this.state.showBanner && (
        <BannerContainer id='SponsoredCarrier' bg='primary.base' width={1} borderRadius='lg'>
          <Flex flexDirection='row'>
            <ImageContainer id='sponsorlogo' onClick={this.filterAirline}>
              <StyledImage src={this.props.imageSrc} alt={this.props.airline} />
            </ImageContainer>
            <SponsorMessage id='sponsorFilterText' onClick={this.filterAirline}>
              Fly with {this.props.airline} for as low as&nbsp;
              <LargeDesktopPrice>
                ${this.props.fromPrice ? this.props.fromPrice.toFixed(2) : 0}
              </LargeDesktopPrice>
              <DesktopPrice>${this.props.fromPrice ? Math.ceil(this.props.fromPrice) : 0}</DesktopPrice>
              .&nbsp;
              <UnderlineText>Show me flights.</UnderlineText>
            </SponsorMessage>
            <CloseButton
              id='sponsorClose'
              onClick={this.hideBanner}
              color='background.lightest'
              size={40}
              title='close'
              name='close'
            />
          </Flex>
        </BannerContainer>
      )
    )
  }
}

SponsoredCarrier.propTypes = {
  imageSrc: PropTypes.string,
  airline: PropTypes.string,
  showBanner: PropTypes.bool.isRequired,
  fromPrice: PropTypes.number,
  selectNoneSelector: PropTypes.string.isRequired,
  filterAirlineSelector: PropTypes.string.isRequired,
  flyGaLogic: PropTypes.shape({
    fire: PropTypes.shape({
      addSetiDimension: PropTypes.func.isRequired,
      sopqAction: PropTypes.func.isRequired,
      popularFlights: PropTypes.func.isRequired,
      sopqUrl: PropTypes.func,
      sponsoredCarrier: PropTypes.func,
    }),
  }),
}
